import { useMemo } from "react"
import CustomGrid from "../../../common/CustomGrid"
import { useFetchGet } from "../../../common/fetchGetApi"
import { FinaltoRoutesName, decimalPlace, timeFormat } from "../utils"
import moment from "moment"


let ColumnData = [
    { field: 'tradeId', headerText: 'ID', width: '210' },
    { field: 'tradeId', headerText: 'Order ID', width: '220' },
    { field: 'time', headerText: 'Time', width: '140', format: timeFormat },
    { field: 'instrument', headerText: 'Instrument', width: '135' },
    { field: 'side', headerText: 'Side', width: '135' },
    { field: 'qty', headerText: 'Qty', width: '115', format: decimalPlace() },
    { field: 'tradePrice', headerText: 'Price', width: '115', format: decimalPlace(5) },
    { field: 'commission', headerText: 'Commission', width: '125' },
]


function HistoryTrades({ startTime, endTime }) {
    const { isLoading, apiData = [], serverError } = useFetchGet(`${FinaltoRoutesName.tradesHistory}?fromTime=${startTime}&toTime=${endTime}`)

    const customApiData = useMemo(() => {
        const newApiData = apiData?.map((data) => ({ ...data, time: moment(data.tradeDate).toISOString(), tradeId: data.tradeId ? String(data.tradeId) : '-' }))
        return newApiData || []
    }, [apiData])

    console.log({ customApiData, apiData })
    return (
        <>
            <CustomGrid ColumnData={ColumnData} apiData={customApiData} isLoading={isLoading} />
        </>
    )
}

export default HistoryTrades